module.exports = __webpack_public_path__ + "static/media/grid-img2.1816c934.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid-img2.svg
// module id = 835
// module chunks = 0